import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Mixin from 'components/common/Mixin'


const Card = ({ ...props }) =>
  <PaymentBlock>
    <Title>A New Way To Save</Title>
    <Discount>Save 10% on your First Purchase!</Discount>
    <BenefitList>
      <BenefitItem>Special promotional offers for cardholders</BenefitItem>
      <BenefitItem>Special Financing options</BenefitItem>
      <BenefitItem>24/7 online account management</BenefitItem>
      <BenefitItem>Additional cards at no extra cost</BenefitItem>
    </BenefitList>
    <ApplyButton>Apply now</ApplyButton>
  </PaymentBlock>

export default Card


const PaymentBlock = styled.div`
  padding: 102px 105px;
  margin: 0 auto;
  background: ${Theme.colors.white};
  background-position: right, right;
  background-repeat: no-repeat, no-repeat;
`

const Title = styled.div`
  margin-bottom: 10px;
  color: ${Theme.colors.blue};
  ${Mixin.font.GothamLight(48, 300)}
`

const Discount = styled.div`
  margin-bottom: 22px;
  font-size: 24px;
  font-weight: 700;
  color: ${Theme.colors.blue};
`

const BenefitList = styled.ul`
  padding-left: 10px;
  list-style-type: none;
`

const BenefitItem = styled.li`
  margin-bottom: 20px;
  padding-left: 15px;
  font-size: 16px;
  font-weight: 300;

  ::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    clear: both;
    margin-right: 15px;
    border-radius: 50%;
    background-color: ${Theme.colors.lightblue};
    vertical-align: middle;
  }
`

const ApplyButton = styled(Button)`
  width: 156px;
  padding: 10px 5px;
  margin-top: 25px;
  border: 0;
  border-radius: 0;
  background: ${Theme.colors.lightblue};
  color: ${Theme.colors.white};
  text-align: center;
`
